import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser, getUserInfo } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'
import routesTaobao2you from './routes/routesTaobao2you'
import tracking from './routes/tracking'
import routesAdmin from './routes/routesAdmin'
import routesAdminBranch from './routes/routesAdminBranch'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home-dashboard' } },
    ...apps,
    ...dashboard,
    ...pages,
    ...routesTaobao2you,
    ...tracking,
    ...routesAdmin,
    ...routesAdminBranch,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach( async (to, _, next) => {
  const userData = JSON.parse(localStorage.getItem('userData'))

  const queryString = window.location.search;
  //all params
  const urlParams = new URLSearchParams(queryString);
  //select params
  const loginCode = urlParams.get('code')
  const orderid = urlParams.get('orderid')
  const loginToken = urlParams.get('token')
  const stateLine = urlParams.get('state')
  //full url
  const toPath = window.location.href
  //only path
  const loginToPath = window.location.pathname
  //trcking path
  const tracking = window.location.pathname
  //check code login
  if (userData != null && userData.data && userData.data.customerInfo && loginCode != null && stateLine == null) {
    if (loginCode != await userData.data.customerInfo.loginToken) {
      // Remove userData from localStorage
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      // Remove userData from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('cusId')
      localStorage.removeItem('all_balance')
      localStorage.removeItem("postcode")
      localStorage.removeItem("category")
      localStorage.removeItem("toPath")

      return next({ name: 'auth-login', params: { toPath: toPath, loginCode: loginCode, loginToPath: loginToPath, orderid: orderid, token: loginToken } })
    }
  } else if (userData != null && userData.data && userData.data.customerInfo && loginToken != null) {
    if (loginToken != await userData.data.customerInfo.loginToken) {
      // Remove userData from localStorage
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      // Remove userData from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('cusId')
      localStorage.removeItem('all_balance')
      localStorage.removeItem("postcode")
      localStorage.removeItem("category")
      localStorage.removeItem("toPath")

      return next({ name: 'auth-login', params: { toPath: toPath, loginCode: loginCode, loginToPath: loginToPath, orderid: orderid, token: loginToken } })
    }
  }
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!getUserInfo() && (tracking == '/search-tracking' || tracking == '/tracking-login')) {
      return next({ name: 'tracking-login'} )
    }

    if (!getUserInfo() == false && (tracking == '/search-tracking' || tracking == '/tracking-login')) {
      return next({ name: 'search-tracking'} )
    }

    if (!isLoggedIn) {
      return next({ name: 'auth-login', params: { toPath: toPath, loginCode: loginCode, loginToPath: loginToPath, orderid: orderid, token: loginToken } })
    }

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  if (to.meta.redirectTrack && !getUserInfo() == false) {
    const userData = getUserInfo()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
